import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventsApiBase } from '../mcap-events/api-base';
import { EventType } from '../../models/event-type.model';

@Injectable({
  providedIn: 'root'
})
export class EventTypeService extends EventsApiBase {
  getEventTypes(ProgramTypeId: number): Observable<EventType[]> {
    return this.get<EventType[]>(
      'api/EventType/GetEventTypes/' + ProgramTypeId,
      {}
    ) as Observable<EventType[]>;
  }

  getRegisteredEventTypes(ProgramTypeGuId: string): Observable<string[]> {
    return this.get<string[]>(
      'api/EventType/GetRegisteredEventTypes/' + ProgramTypeGuId,
      {}
    ) as Observable<string[]>;
  }
}
